import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import ResetPasswordForm from '../../components/Form/ResetPasswordForm/ResetPasswordForm'
import { userActions } from '../../redux/actions'

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hashKey: null,
    }

    const {
      location: { search },
    } = this.props
    if (search) {
      const params = search.split('?')[1].split('&')
      const hashKey = params
        .map(param => ({
          key: param.split('=')[0],
          value: param.split('=')[1],
        }))
        .find(param => param.key === 'code')
      if (hashKey) {
        this.state.hashKey = hashKey.value
      }
    }
  }

  onSetNewPassword = values => {
    const { hashKey } = this.state
    const { resetPassword } = this.props

    const mergedValues = {
      ...values,
      key: hashKey,
    }

    return resetPassword(mergedValues)
  }

  handleModalClose = isLoggedIn => {
    const { history } = this.props
    if (isLoggedIn) {
      history.push('/claim-reward')
    } else {
      history.push('/login')
    }
  }

  // eslint-disable-next-line react/destructuring-assignment
  _isKeyValid = () => !!this.state.hashKey

  render() {
    let paragraphContent = null
    if (this._isKeyValid()) {
      paragraphContent = (
        <p
          aria-label={this.props.intl.formatMessage({
            id: 'page.resetPasswordPage.title.description',
          })}
        >
          <FormattedMessage id="page.resetPasswordPage.title.description" />
        </p>
      )
    } else {
      paragraphContent = (
        <p
          aria-label={this.props.intl.formatMessage({
            id: 'page.resetPasswordPage.general.keyError',
          })}
        >
          <FormattedMessage id="page.resetPasswordPage.general.keyError" />
        </p>
      )
    }
    const { intl } = this.props
    const { hashKey } = this.state
    const label = intl.formatMessage({ id: 'page.resetPasswordPage.title.heroTitle' })

    return (
      <div className="reset-password-page" role="main" aria-label={label} tabIndex={-1}>
        <Helmet>
          <title>{label}</title>
        </Helmet>
        <div className="container mt-5 mb-5">
          <h1
            className="page-title"
            aria-level="1"
            aria-label={intl.formatMessage({ id: 'page.resetPasswordPage.title.heroTitle' })}
          >
            <FormattedMessage id="page.resetPasswordPage.title.heroTitle" />
          </h1>
          {paragraphContent}
          <small>
            <p aria-label={intl.formatMessage({ id: 'page.resetPasswordPage.title.note' })}>
              <FormattedMessage id="page.resetPasswordPage.title.note" />
            </p>
          </small>
          {hashKey && (
            <div className="row justify-content-center">
              <div className="col-md-8 col-xl-6">
                <ResetPasswordForm
                  onSubmit={this.onSetNewPassword}
                  onModalClose={this.handleModalClose}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  resetPassword: (...args) => dispatch(userActions.resetPassword(...args)),
})

export default injectIntl(withRouter(connect(null, mapDispatchToProps)(ResetPassword)))
